import { ArrayHelpers, Box, DomHelpers, Help, Loading, Paging, StringHelpers, SystemText } from 'e4shared';
import React, { useEffect } from 'react';
import PerformanceCompetencyCard from './components/performanceCompetencyCard';

export const Behaviours = ({ profile, text, onFlag, show, data, pathways, loading, reloading }) => {
    const [page, setPage] = React.useState(1);
    const [ratedData, setRatedData] = React.useState([]);

    React.useEffect(() => {
        if (data?.length) {
            setRatedData(data.filter(x => x.rating));
        } else {
            setRatedData([]);
        }
    }, [data]);

    React.useEffect(() => {
        const resizeHandler = () => DomHelpers.arrangeTiles('behaviour-sync');
        setTimeout(() => resizeHandler(), 250);
        window.addEventListener('resize', resizeHandler);

        return () => {
            window.removeEventListener('resize', resizeHandler);
        };
    }, [page, loading]);

    return (
        <>
            <div className="flex flex-row">
                <h4 className="flex-grow">
                    <span>{text.behaviours.title}</span>
                    <span className="text-sm">
                        <Help id="help-title">{text.behaviours.help}</Help>
                    </span>
                </h4>
                {!loading && !pathways?.length && ratedData.length > 0 && (
                    <Paging
                        recordCount={ratedData?.length > 12 ? 12 : ratedData?.length}
                        pageSize="4"
                        page={page}
                        goToPage={setPage}
                        bullets
                    />
                )}
            </div>
            {loading ? (
                <Loading />
            ) : pathways?.length || ratedData.length === 0 ? (
                <Box className="mt10">
                    <div className="flex flex-center">
                        <i className="fa fa-warning text-danger mr10" />
                        <span className="flex-grow">
                            {ratedData.length === 0
                                ? text.behaviours.noResults
                                : text.pathways(StringHelpers.arrayToString(pathways, ',', SystemText('General/Lists/And')))}
                        </span>
                    </div>
                </Box>
            ) : (
                <div className="behaviour-cards">
                    {ArrayHelpers.getPage(ratedData, page, 4).map(c => (
                        <div key={`behaviour-${c.id}`}>
                            <PerformanceCompetencyCard
                                competency={c}
                                text={text}
                                reloading={reloading}
                                onFlag={onFlag}
                                profile={profile}
                                show={show}
                            />
                        </div>
                    ))}
                </div>
            )}
        </>
    );
};

export default Behaviours;
